import React from "react";
import { JSX } from "react/jsx-runtime";

const NextArrowIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="12.135" cy="12.136" r="11.3855" transform="rotate(-90 12.135 12.136)" fill="#5376F0" stroke="#5376F0" stroke-width="1.5"/>
        <path d="M17.5298 12.8018C17.8227 12.5089 17.8227 12.034 17.5298 11.7412L12.7569 6.96818C12.464 6.67529 11.9891 6.67529 11.6962 6.96818C11.4033 7.26108 11.4033 7.73595 11.6962 8.02884L15.9389 12.2715L11.6962 16.5141C11.4033 16.807 11.4033 17.2819 11.6962 17.5748C11.9891 17.8677 12.464 17.8677 12.7569 17.5748L17.5298 12.8018ZM5.99951 13.0215L16.9995 13.0215L16.9995 11.5215L5.99951 11.5215L5.99951 13.0215Z" fill="white"/>
    </svg>
  )
}

export default NextArrowIcon;